import { XMarkIcon } from '@heroicons/react/20/solid';

import { InlineSelect } from '../../../../../common/Atoms/InlineSelect';
import { classNames } from '../../../../../common/lib/classNames';
import { useContactTags } from '../../../../hooks/useContactTags';
import { TagBadge } from '../../../Molecules/TagBadge';

interface ITagPillsProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
  /** Small pills for contact people */
  small?: boolean;
}

/** Contact tags as removable pills, then a dashed "+ Tag" picker over the org's contact tags */
export function TagPills({ tags, onChange, disabled, small }: ITagPillsProps) {
  const { tags: allTags, colorMap } = useContactTags();
  const size = small ? `h-[1.125rem] px-[0.4375rem] text-[0.6875rem]` : `h-[1.625rem] px-2 text-xs`;

  return (
    <>
      { tags.map(tag => (
        // Tags without their own colour use the brand tint
        <TagBadge
          key={ tag }
          name={ tag }
          color={ colorMap[tag] }
          className={ classNames(size, `gap-0.5 whitespace-nowrap bg-paidniceGreen-50 py-0 pr-1 text-paidniceGreen-800`) }
        >
          <button
            type={ `button` }
            aria-label={ `Remove tag ${tag}` }
            title={ `Remove tag` }
            disabled={ disabled }
            onClick={ () => onChange(tags.filter(t => t !== tag)) }
            className={ `cursor-pointer rounded-full opacity-60 hover:opacity-100 disabled:cursor-not-allowed` }
          >
            <XMarkIcon className={ small ? `h-3 w-3` : `h-3.5 w-3.5` } />
          </button>
        </TagBadge>
      )) }
      <InlineSelect
        multiple
        hideChevron
        options={ allTags.map(tag => ({ value: tag, label: tag })) }
        value={ tags }
        onChange={ onChange }
        disabled={ disabled }
        display={ `+ Tag` }
        className={ classNames(
          `whitespace-nowrap rounded-full border border-dashed border-gray-300 bg-white text-gray-500 hover:border-paidniceGreen-200 hover:text-paidniceGreen-600`,
          size,
        ) }
      />
    </>
  );
}
